module.exports = __webpack_public_path__ + "media/features/audio-hero/images/phones_mobile_de@2x-f89fd3f72bbbceeaaa5ba78b6b8f1370.png";